import PanToolIcon from '@mui/icons-material/PanTool';
import { GenericError } from "./GenericError";
import { iconStyle } from "./styled";

export const AnonUnauthorizedError = () => (<GenericError
  icon={<PanToolIcon sx={iconStyle} />}
  header={"You are not authorized to perform this action"}
  subText={"You may need to sign-in to continue"}
/>);